module.exports = __webpack_public_path__ + "img/role_2.5c2735bd.png";